const AddressType = {
  CompanyAddress: {
    id: 1,
    name: "CompanyAddress",
  },
  BillingAddress: {
    id: 2,
    name: "BillingAddress",
  },
  AdditionalAddress: {
    id: 3,
    name: "AdditionalAddress",
  },
};

export default AddressType;
